import * as React from 'react';
import { observer } from 'mobx-react';
import { Tooltip } from '@payscale/design';

export interface IInactiveBudgetTooltip {
    id: number;
    hidden: boolean;
}

@observer
export default class InactiveBudgetTooltip extends React.Component<IInactiveBudgetTooltip> {
    render(): React.ReactNode {
        const { id, hidden } = this.props;
        if (hidden) {
            return null;
        }

        return (
            <div className="tooltip pxl-text-xs">
                <Tooltip
                    className=""
                    hoverText="Budget that has no associated field will not show up in the team view."
                    tooltipText="Inactive"
                    id={`inactiveTooltip${id}`}
                />
            </div>
        );
    }
}